import axios from 'axios';
import { spaceClient } from './client';
import { API_BASE } from './apiConfig';

// ── Items ──────────────────────────────────────────────────────────────────
export const getItems = () =>
  spaceClient.get('/cms/item', { withCredentials: true }).then((r) => r.data);

export const getItemById = (id) =>
  spaceClient.get(`/cms/item/${id}`, { withCredentials: true }).then((r) => r.data);

export const createItem = (data) =>
  spaceClient.post('/item', data, { withCredentials: true }).then((r) => r.data);

export const updateItem = (id, data) =>
  spaceClient.put(`/item/${id}`, data, { withCredentials: true }).then((r) => r.data);

export const deleteItem = (id) =>
  spaceClient.delete(`/item/${id}`, { withCredentials: true }).then((r) => r.data);

// Lean id/type/name/thumbnail projection of the full catalog (minus price-only items) —
// [{ itemId, itemTypeId, name, thumbnailUrl }]. For a thumbnail-grid picker (Game
// Announcement prize-pack picker); avoids calling the heavy /cms/item endpoint above
// (usp_Item_SelectBySpace — pricing/discount/approval/per-locale joins) just to render a
// name and an image. See migration/game-announcement.sql, sp_Item_SelectPickerBySpace.
export const getItemPicker = () =>
  spaceClient.get('/item/picker').then((r) => r.data);

// ── Discount Campaigns ──────────────────────────────────────────────────────
export const getDiscounts = () =>
  spaceClient.get('/cms/discounts', { withCredentials: true }).then((r) => r.data);

export const createDiscount = (data) =>
  spaceClient.post('/discounts', data, { withCredentials: true }).then((r) => r.data);

export const updateDiscount = (id, data) =>
  spaceClient.put(`/discounts/${id}`, data, { withCredentials: true }).then((r) => r.data);

export const deleteDiscount = (id) =>
  spaceClient.delete(`/discounts/${id}`, { withCredentials: true }).then((r) => r.data);

// ── Free Trial ────────────────────────────────────────────────────────────
export const getFreeTrialSetting = () =>
  spaceClient.get('/cms/free-trials/setting', { withCredentials: true }).then((r) => r.data);

export const createFreeTrialSetting = (data) =>
  spaceClient.post('/free-trials/setting', data, { withCredentials: true }).then((r) => r.data);

export const updateFreeTrialSetting = (data) =>
  spaceClient.put('/free-trials/setting', data, { withCredentials: true }).then((r) => r.data);

export const getFreeTrialItems = () =>
  spaceClient.get('/cms/free-trials/items', { withCredentials: true }).then((r) => r.data);

export const addFreeTrialItem = (itemId) =>
  spaceClient.post('/free-trials/items', { itemId }, { withCredentials: true }).then((r) => r.data);

export const removeFreeTrialItem = (itemId) =>
  spaceClient.delete(`/free-trials/items/${itemId}`, { withCredentials: true }).then((r) => r.data);

export const addFreeTrialPackage = (packageId) =>
  spaceClient.post('/free-trials/items', { packageId }, { withCredentials: true }).then((r) => r.data);

export const removeFreeTrialPackage = (packageId) =>
  spaceClient.delete(`/free-trials/packages/${packageId}`, { withCredentials: true }).then((r) => r.data);

export const getFreeTrialClaims = () =>
  spaceClient.get('/cms/free-trials/claims', { withCredentials: true }).then((r) => r.data);

// ── Tax Categories ──────────────────────────────────────────────────────────
export const getTaxCategories = () =>
  spaceClient.get('/tax-categories', { withCredentials: true }).then((r) => r.data);

export const createTaxClass = (data) =>
  spaceClient.post('/tax-categories', data, { withCredentials: true }).then((r) => r.data);

// ── Lookup Tables ───────────────────────────────────────────────────────────
export const getItemTypes = () =>
  axios.get(`${API_BASE}/api/lookups/item-types`, { withCredentials: true }).then((r) => r.data);

export const getMerchandiseTypes = () =>
  axios.get(`${API_BASE}/api/lookups/merchandise-types`, { withCredentials: true }).then((r) => r.data);

export const getMerchandiseCategories = () =>
  axios.get(`${API_BASE}/api/lookups/merchandise-categories`, { withCredentials: true }).then((r) => r.data);

// ── Merchandise Type CRUD ───────────────────────────────────────────────────
export const createMerchandiseType = (data) =>
  axios.post(`${API_BASE}/api/merchandise-types`, data, { withCredentials: true }).then((r) => r.data);

export const updateMerchandiseType = (id, data) =>
  axios.put(`${API_BASE}/api/merchandise-types/${id}`, data, { withCredentials: true }).then((r) => r.data);

export const deleteMerchandiseType = (id) =>
  axios.delete(`${API_BASE}/api/merchandise-types/${id}`, { withCredentials: true });

// ── Merchandise Category CRUD ───────────────────────────────────────────────
export const createMerchandiseCategory = (data) =>
  axios.post(`${API_BASE}/api/merchandise-categories`, data, { withCredentials: true }).then((r) => r.data);

export const updateMerchandiseCategory = (id, data) =>
  axios.put(`${API_BASE}/api/merchandise-categories/${id}`, data, { withCredentials: true }).then((r) => r.data);

export const deleteMerchandiseCategory = (id) =>
  axios.delete(`${API_BASE}/api/merchandise-categories/${id}`, { withCredentials: true });

export const getTicketTypes = () =>
  axios.get(`${API_BASE}/api/lookups/ticket-types`, { withCredentials: true }).then((r) => r.data);

export const getCurrencies = () =>
  axios.get(`${API_BASE}/api/lookups/currencies`, { withCredentials: true }).then((r) => r.data);
